import styled from "@emotion/styled";
import DOMPurify from "dompurify";
import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { CHEVRON_RIGHT_ICON } from "../../utils/svgs_new";
import { AppButton } from "../Generic/AppButton";
import { AppIcon } from "../Generic/AppIcon";
import Flex from "../Generic/Flex";
import { default as DoctorIllustration } from "/public/assets/doctor-illustration.svg?react";
import { default as TriangularWarningIcon } from "/public/assets/triangular-warning-icon.svg?react";

export interface ComplianceBannerProps {
  title: string;
  message: string;
  multipleComplianceItems: boolean;
  onClick: () => void;
}

const ComplianceBanner = (props: ComplianceBannerProps) => {
  return (
    <ComplianceBanner.Root>
      <ComplianceBanner.Container>
        <ComplianceBanner.Content>
          <ComplianceBanner.Title>
            <TriangularWarningIcon />
            {props.title}
          </ComplianceBanner.Title>
          <ComplianceBanner.Message
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.message) }}
          />
          <ComplianceBanner.Button>
            <AppButton onClick={props.onClick}>
              <Flex direction="row" gap={4} alignItems="center">
                {props.multipleComplianceItems
                  ? translate(STRINGS.FIX_ISSUES)
                  : translate(STRINGS.FIX_ISSUE)}
                <AppIcon icon={CHEVRON_RIGHT_ICON} />
              </Flex>
            </AppButton>
          </ComplianceBanner.Button>
        </ComplianceBanner.Content>
        <ComplianceBanner.DoctorIcon>
          <DoctorIllustration />
        </ComplianceBanner.DoctorIcon>
      </ComplianceBanner.Container>
    </ComplianceBanner.Root>
  );
};

export default ComplianceBanner;

ComplianceBanner.Root = styled.div`
  padding: 0 16px;
`;

ComplianceBanner.Container = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  background: #feecec;
  padding: 16px;
`;

ComplianceBanner.Content = styled.div`
  display: flex;
  flex-direction: column;
`;

ComplianceBanner.Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-weight: 700;
`;

ComplianceBanner.Message = styled.div`
  margin-top: 4px;
`;

ComplianceBanner.Button = styled.div`
  margin-top: 11px;
  .AppButton {
    border-radius: 12px;
    height: 32px;
  }
`;

ComplianceBanner.DoctorIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
